import { ComponentStyleConfig } from '@chakra-ui/react';

export const FormError: ComponentStyleConfig = {
  baseStyle: {
    text: {
      pl: 3,
      mt: 1,
      fontSize: 'xs',
      textAlign: 'left',
    },
  },
};
